// Données partagées des travaux — utilisées par toutes les versions de la page Work.

export const WORKS = [
  { label: "Kara fusion", link: "/page1", image: "/images/aQDY57pReVYa3wgp_Olympikus01.avif", cat: "conception", subtitle: "Fusion des cultures" },
  { label: "Paul rand", link: "/page2", image: "/images/download (2).mp4", cat: "conception", subtitle: "Hommage au maître" },
  { label: "Moya sauce", link: "/page3", image: "/images/aaW8LjPJ2QKSVUJw_01_RohinhoodMarket.avif", cat: "production", subtitle: "Piquant de caractère" },
  { label: "Claquette club", link: "/page4", image: "/images/aQEWorpReVYa3xLG_PORTOROCHA_BPMMusic_1.avif", cat: "strategie", subtitle: "Le club des icônes" },
  { label: "Virunga coffee", link: "/page5", image: "/images/download.mp4", cat: "conception", subtitle: "Arômes des volcans" },
  { label: "Maniac gtk", link: "/page6", image: "/images/aP_MDbpReVYa3uZr_PORTOROCHA_Samba1.avif", cat: "production", subtitle: "Énergie brute" },
  { label: "WeareGrapp", link: "/page7", image: "/images/aMFtF2GNHVfTO_Qo_image382.avif", cat: "strategie", subtitle: "Collectif en mouvement" },
  { label: "Muganza", link: "/page8", image: "/images/download (3).mp4", cat: "conception", subtitle: "Racines & modernité" },
  { label: "Auto izy", link: "/page9", image: "/images/aQEecLpReVYa3xXi_PORTOROCHA_VEEPS_1-Cover.avif", cat: "production", subtitle: "La route autrement" },
  { label: "Cinemascope", link: "/page10", image: "/images/aP_ck7pReVYa3uia_PORTOROCHA_YAGA1.avif", cat: "conception", subtitle: "Grand écran, grandes idées" },
  { label: "Bakeli", link: "/page11", image: "/images/download (1).mp4", cat: "conception", subtitle: "Cuisine des idées" },
  { label: "Papier bulle", link: "/page12", image: "/images/aQAttbpReVYa3u6Z_PortoRocha_UpworkCaseStudy01.avif", cat: "production", subtitle: "Fragile et précieux" },
  { label: "Ndoto club", link: "/page13", image: "/images/aQETl7pReVYa3xHN_PORTOROCHA_Shop_1.avif", cat: "strategie", subtitle: "La nuit rêvée" },
  { label: "Zaza express", link: "/page14", image: "/images/download (4).mp4", cat: "conception", subtitle: "Vitesse grand V" },
];

const CAT_LABELS = {
  conception: 'Conception graphique',
  production: 'Production',
  strategie: 'Stratégie',
};

export const catLabel = (cat) => CAT_LABELS[cat] || '';

export const isVideo = (src) => /\.(mp4|webm|mov)$/i.test(src || '');

// Les visuels d'un travail peuvent être de simples URLs (ancien format)
// ou des objets { url, role } (rôle : principale | secondaire | sous)
export const mediaUrl = (m) => (typeof m === 'string' ? m : (m && m.url) || '');
export const mediaRole = (m) =>
  typeof m === 'string' ? 'principale' : (m && m.role) || 'principale';

// Image de garde d'un travail ajouté depuis l'admin : celle marquée
// `cover`, sinon la première de la liste (comportement d'avant).
export const coverUrl = (work) => {
  const imgs = (work && work.images) || [];
  const cover = imgs.find((m) => m && typeof m === 'object' && m.cover);
  return mediaUrl(cover || imgs[0]);
};
